import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Container } from './styles';

interface ButtonProps {
  title: string;
  onClick?: () => void;
  textColor?: string;
  backgroundColor?: string;
  maxWidth?: number;
  border?: string;
  padding?: string;
  marginLeft?: string;
  disabled?: boolean;
  radius?: number;
  icon?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const Button: FC<ButtonProps> = ({
  title,
  onClick,
  backgroundColor,
  textColor,
  maxWidth,
  border,
  padding,
  marginLeft,
  disabled,
  radius,
  icon,
  type,
}) => {
  return (
    <Container
      type={type || 'button'}
      disabled={disabled}
      onClick={onClick}
      backgroundColor={backgroundColor}
      textColor={textColor}
      maxWidth={maxWidth}
      border={border}
      padding={padding}
      marginLeft={marginLeft}
      isDisabled={disabled}
      radius={radius}
    >
      {title}
      {icon && <FontAwesomeIcon style={{ marginLeft: '8px' }} icon={faCheck} />}
    </Container>
  );
};

export default Button;
